import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ButtonModule } from 'primeng/button';
import { AuthService } from "@app/core/auth";
import { PERMISSION } from "@app/constants";

@Component({
  selector: "app-data-display",

  imports: [CommonModule, ButtonModule],
  templateUrl: "./data-display.component.html",
  styleUrl: "./data-display.component.scss",
})
export class DataDisplayComponent {
  @Input()
  label: string = "";

  @Input()
  value: string | null | undefined | unknown = "";

  @Input()
  toggleValue: string | null | undefined | unknown = "";

  @Input()
  showToggle: boolean = false;

  @Input()
  severity:
    | "success"
    | "warn"
    | "info"
    | "danger"
    | "secondary"
    | "contrast"
    | undefined;

  @Input()
  isToggled: boolean = false;

  @Output()
  toggleChanged = new EventEmitter<boolean>();
 claims!: string[];

  constructor(
        private readonly authService: AuthService,
  ) {
        this.claims = authService.getPermissions();
  }

  toggleVisibility() {
    this.isToggled = !this.isToggled;
    this.toggleChanged.emit(this.isToggled);
  }

  get displayValue() {
    return (this.showToggle && this.isToggled) ? this.toggleValue : this.value;
  }
    protected readonly PERMISSION = PERMISSION;
}
